import {
  DELETE_CONTINUE_VIEWING_ITEM,
  GET_CMS_LEVEL_NODE_INFO,
  REMOVE_MY_LIST_ITEM,
  SET_CMS_CONTENT_LIST,
  DELETE_POSTER_RECORDING,
} from './../constants';

const initialState = {};

const cmsNodes = (state = initialState, action) => {
  const cmsNode = state[(action.payload?.node)];
  switch (action.type) {
    case GET_CMS_LEVEL_NODE_INFO:
      return {
        ...state,
        [action.payload.node]: {
          ...state[action.payload.node],
          loaded: action.payload.loaded,
          carousels: action.payload.cmsLevelModules,
          userHash: action.payload.userHash,
        },
      };
    case SET_CMS_CONTENT_LIST:
      return {
        ...state,
        [action.payload.node]: {
          ...cmsNode,
          carousels: cmsNode?.carousels?.map((carousel, i) => {
            if (i === action.payload.index) {
              if (action?.payload?.contentList?.groups?.groups) {
                return {
                  ...carousel,
                  contentsList: action?.payload?.contentList?.groups?.groups,
                  hasError: action.payload?.hasError || false,
                };
              }

              if (action?.payload?.contentList?.groups) {
                return {
                  ...carousel,
                  contentsList: action?.payload?.contentList?.groups,
                  hasError: action.payload?.hasError || false,
                };
              }

              if (action?.payload?.contentList?.highlight) {
                return {
                  ...carousel,
                  contentsList: action?.payload?.contentList?.highlight,
                  hasError: action.payload?.hasError || false,
                };
              }

              if (action.payload.contentList?.listButtons?.button) {
                return {
                  ...carousel,
                  contentsList: action.payload.contentList?.listButtons?.button,
                  hasError: action.payload?.hasError || false,
                };
              }
              if (action?.payload?.contentList?.channels) {
                return {
                  ...carousel,
                  contentsList: action?.payload?.contentList?.channels,
                  hasError: action.payload?.hasError || false,
                };
              }

              if (action?.payload?.contentList?.events) {
                return {
                  ...carousel,
                  contentsList: action?.payload?.contentList?.events,
                  hasError: action.payload?.hasError || false,
                };
              }
              if (
                action?.payload.contentList?.length === 0 &&
                action?.payload?.hasError
              ) {
                return {
                  ...carousel,
                  contentsList: action?.payload?.contentList,
                  hasError: action?.payload?.hasError,
                };
              }
            }

            return {
              ...carousel,
            };
          }),
        },
      };
    case DELETE_CONTINUE_VIEWING_ITEM:
    case REMOVE_MY_LIST_ITEM:
      return {
        ...state,
        [action.payload.node]: {
          ...cmsNode,
          carousels: cmsNode?.carousels.map((carousel, index) => {
            if (index === action.payload.index) {
              return {
                ...carousel,
                contentsList: carousel.contentsList.filter(
                  content => content.id !== action.payload.contentId,
                ),
              };
            } else {
              return { ...carousel };
            }
          }),
        },
      };

    case DELETE_POSTER_RECORDING: {
      const { node, index, dataCurrenPoster } = action?.payload || {};

      const deletePosterFromState = contentsList => {
        const newList = contentsList?.filter(poster => {
          if (dataCurrenPoster?.IsEvent) {
            return poster?.record_id !== dataCurrenPoster?.id;
          }
          // si no es un evento significa que es una serie
          return poster?.serie_id !== dataCurrenPoster?.id;
        });
        return newList;
      };

      const newStateCarousels = {
        ...state,
        [node]: {
          ...cmsNode,
          carousels: cmsNode?.carousels?.map((carousel, i) => {
            if (i === index) {
              return {
                ...carousel,
                contentsList: deletePosterFromState(carousel?.contentsList),
              };
            }

            return { ...carousel };
          }),
        },
      };

      return { ...newStateCarousels };
    }

    default:
      return state;
  }
};

export default cmsNodes;
